module.exports = __webpack_public_path__ + "img/AnnAmeling.de3aeee1.jpg";